var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradeEventArrowLeftUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.9 10.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 62.9 0 L 62.9 34.1 L 0 34.1 Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 33.1 C 1 33.1 18.7 -1.1 54.3 5.4",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#6234b0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "5.861,3.861"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.9 10.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 62.9 0 L 62.9 34.1 L 0 34.1 Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.7 10.7 L 61.5 5.8 L 56.6 1",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#6234b0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeEventArrowLeftUp);
export default __webpack_public_path__ + "static/media/trade_event_arrow_left_up.25aaf76c07b132432c63fb2997ae8cd8.svg";
export { ForwardRef as ReactComponent };